import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';

import { ComponentDataTransformerService, ExcelGenerateService } from './services';

@NgModule({
	imports: [
		CommonModule,
		CwpNgFrameworkModule
	],
	providers: [
		ExcelGenerateService,
		ComponentDataTransformerService
	]
})
export class ExcelGenerateModule { }
